import { inject, Injectable } from '@angular/core';
import { ContactsApiService, CustomerApiService } from '@dxp/core/api';
import { IContact, ICustomFieldDefinition } from '@dxp/core/models';
import { Observable, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ContactDirectoriesApiService {
    readonly #contactApiService = inject(ContactsApiService);
    readonly #customerApiService = inject(CustomerApiService);

    updateContact(contact: IContact): Observable<void> {
        return this.#contactApiService.updateContact(contact);
    }

    fetchCustomFields(): Observable<ICustomFieldDefinition[]> {
        return this.#customerApiService
            .getCustomFields(null)
            .pipe(switchMap(customFields => [customFields.fieldDefinitions]));
    }
}
